<template>
  <div class="container">
    <div class="imgBanner"></div>
    <div class="container-contents" v-if="show">
      <div class="bodyText">
        <div class="htmltext">
          <p>1、资质等级分为实习级、初级、中级、高级共四档，逐级进行升级</p>
          <p>2、每档资质升级所需条件： a、实习级 须满足…………………… b、初级</p>
          <p>须满足…………………… c、中级 须满足…………………… d、高级 须满足……………………</p>
          <p>
            3、资质升级需提交个人信息、当前从业单位信息以及从事的案例相关附件，审核通过后资质等级会自动在原等级基础上上升一级
          </p>
        </div>
      </div>
      <div class="typeInfo">
        <div class="headerType">
          <span></span>
          <h1>资质类别</h1>
          <span></span>
        </div>
        <div class="itemType">
          <div @click="typeFun(1)">创新管理师</div>
          <div @click="typeFun(2)">分级评价人员</div>
          <div @click="typeFun(3)">知识产权质量评价人员</div>
        </div>
      </div>
    </div>
    <div class="container-content" v-else>
      <el-steps :active="active" align-center finish-status="success">
        <el-step title="填报信息"></el-step>
        <!-- <el-step title="填写单位信息"></el-step> -->
        <el-step title="上传案例附件"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
      <div class="topGrade" v-show="active == 0">
        <div class="left">
          <h1>升级前资质等级</h1>
          <p style="font-size: 30px">{{ nowQualLevel }}</p>
        </div>
        <div class="right">
          <h1>升级后资质等级</h1>
          <p style="font-size: 30px">{{ applyQualLevel }}</p>
        </div>
      </div>
      <div class="container-form">
        <div class="item_frist" v-show="active == 0">
          <div class="titleheader">个人信息</div>
          <el-form
            ref="ruleForm"
            :model="ruleForm"
            align="left"
            :rules="rules"
            class="eg_form"
          >
            <el-row :gutter="20">
              <el-col :span="12"
                ><el-form-item
                  label="姓名："
                  prop="userName"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    v-model="ruleForm.userName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="性别："
                  prop="sex"
                  :label-width="formLabelWidth"
                >
                  <el-radio-group v-model="ruleForm.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="2">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12"
                ><el-form-item
                  label="证件类型："
                  prop="idcardType"
                  :label-width="formLabelWidth"
                >
                  <el-select
                    v-model="ruleForm.idcardType"
                    placeholder="请选择证件类型"
                  >
                    <el-option
                      v-for="(item, index) in idCardList"
                      :key="index"
                      :label="item.value"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="证件号码："
                  prop="idcardNum"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    v-model="ruleForm.idcardNum"
                    type="text"
                    auto-complete="off"
                    placeholder="请输入证件号"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12"
                ><el-form-item
                  label="联系手机："
                  prop="mobilePhone"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    placeholder="请输入"
                    v-model="ruleForm.mobilePhone"
                  ></el-input> </el-form-item
              ></el-col>

              <el-col :span="12">
                <el-form-item
                  label="电子邮箱："
                  prop="email"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    placeholder="请输入"
                    v-model="ruleForm.email"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12"
                ><el-form-item
                  label="职称："
                  prop="technicalTitle"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    placeholder="请输入"
                    v-model="ruleForm.technicalTitle"
                  ></el-input> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item
                  label="详细地址："
                  required
                  :label-width="formLabelWidth"
                >
                  <div class="seleCity">
                    <el-form-item prop="province"
                      ><el-select
                        v-model="ruleForm.province"
                        placeholder="省"
                        value-key="area_code"
                        @change="getprovince($event)"
                      >
                        <el-option
                          v-for="(item, index) in province"
                          :key="index"
                          :label="item.area_name"
                          :value="item"
                        ></el-option> </el-select
                    ></el-form-item>

                    <el-form-item prop="city"
                      ><el-select
                        v-model="ruleForm.city"
                        placeholder="市"
                        value-key="area_code"
                        @change="getcity($event)"
                      >
                        <el-option
                          v-for="(item, index) in city"
                          :key="index"
                          :label="item.area_name"
                          :value="item"
                        ></el-option> </el-select
                    ></el-form-item>

                    <el-form-item prop="county">
                      <el-select
                        v-model="ruleForm.county"
                        placeholder="区/县"
                        value-key="area_code"
                        @change="getarea($event)"
                      >
                        <el-option
                          v-for="(item, index) in area"
                          :key="index"
                          :label="item.area_name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <el-form-item prop="address" style="width: 100%">
                    <el-input
                      v-model="ruleForm.address"
                      type="text"
                      placeholder="请输入详细地址"
                    ></el-input>
                  </el-form-item> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col>
                <el-form-item
                  label="个人简介："
                  prop="personIntroduction"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    v-model="ruleForm.personIntroduction"
                    type="textarea"
                    placeholder="请输入个人简介"
                    maxlength="500"
                    rows="3"
                  ></el-input>
                </el-form-item> </el-col
            ></el-row>
          </el-form>
        </div>
        <div class="item_second" v-show="active == 0">
          <div class="titleheader">单位信息</div>
          <el-form
            ref="ruleForms"
            :model="ruleForm"
            align="left"
            :rules="rules"
            class="eg_form"
          >
            <el-row :gutter="20">
              <el-col :span="12"
                ><el-form-item
                  label="单位名称："
                  prop="unitName"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    v-model="ruleForm.unitName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="统一社会信用代码："
                  prop="creCode"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    v-model="ruleForm.creCode"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12"
                ><el-form-item
                  label="所在部门："
                  prop="depart"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    v-model="ruleForm.depart"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="所在岗位："
                  prop="post"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    v-model="ruleForm.post"
                    type="text"
                    auto-complete="off"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="技术领域："
                  prop="industry"
                  :label-width="formLabelWidth"
                >
                  <el-select
                    v-model="ruleForm.industry"
                    placeholder="请选择技术领域"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in listIndustry"
                      :key="index"
                      :label="item.value"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  prop="dutyTime"
                  label="工作开始时间："
                  :label-width="formLabelWidth"
                >
                  <el-date-picker
                    v-model="ruleForm.dutyTime"
                    type="date"
                    style="width: 100%"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="详细地址："
                  required
                  :label-width="formLabelWidth"
                >
                  <div class="seleCity">
                    <el-form-item prop="workprovince"
                      ><el-select
                        v-model="ruleForm.workprovince"
                        placeholder="省"
                        value-key="area_code"
                        @change="workProvince($event)"
                      >
                        <el-option
                          v-for="(item, index) in province"
                          :key="index"
                          :label="item.area_name"
                          :value="item"
                        ></el-option> </el-select
                    ></el-form-item>

                    <el-form-item prop="workcity"
                      ><el-select
                        v-model="ruleForm.workcity"
                        placeholder="市"
                        value-key="area_code"
                        @change="workCity"
                      >
                        <el-option
                          v-for="(item, index) in city"
                          :key="index"
                          :label="item.area_name"
                          :value="item"
                        ></el-option> </el-select
                    ></el-form-item>

                    <el-form-item prop="workcounty">
                      <el-select
                        v-model="ruleForm.workcounty"
                        placeholder="区/县"
                        value-key="area_code"
                        @change="workArea"
                      >
                        <el-option
                          v-for="(item, index) in area"
                          :key="index"
                          :label="item.area_name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <el-form-item prop="unitAddress" style="width: 100%">
                    <el-input
                      v-model="ruleForm.unitAddress"
                      type="text"
                      placeholder="请输入详细地址"
                    ></el-input>
                  </el-form-item> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col>
                <el-form-item
                  label="单位简介："
                  prop="workText"
                  :label-width="formLabelWidth"
                >
                  <el-input
                    v-model="ruleForm.workText"
                    type="textarea"
                    placeholder="请输入单位简介"
                    maxlength="500"
                    rows="3"
                  ></el-input>
                </el-form-item> </el-col
            ></el-row>
          </el-form>
        </div>
        <div class="item_three" v-show="active == 1">
          <el-upload
            class="upload-demo"
            :on-remove="handleRemove"
            :on-change="submitUploadtable"
            :file-list="fileList"
            drag
            accept=".pdf,.doc,.docx"
            :auto-upload="false"
            action="#"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
              <p style="font-size: 12px; color: #999; margin-top: 10px">
                文件扩展名：.doc.docx.pdf
              </p>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </div>
        <div class="item_four" v-show="active == 2">
          <i
            class="el-icon-success"
            style="
              font-size: 100px;
              margin-bottom: 20px;
              color: rgb(3, 161, 16);
            "
          ></i>
          <h3>操作成功</h3>
          <el-button
            v-if="active == 2"
            @click="back"
            style="padding: 12px 70px; margin-top: 80px"
            >返回</el-button
          >
        </div>
      </div>
      <div class="button">
        <el-button
          type="warning"
          style="margin-top: 12px"
          @click="prev"
          v-if="active == 1"
          >返回上一步</el-button
        >
        <el-button
          type="primary"
          style="margin-top: 12px"
          @click="next"
          v-if="active == 0"
          >保存并进入下一步</el-button
        >
        <el-button
          type="primary"
          style="margin-top: 12px"
          @click="submit"
          :disabled="disable"
          v-if="active == 1"
          >提交</el-button
        >
      </div>
    </div>
    <Foot />
  </div>
</template>
  
<script>
import Foot from "./Foot.vue";
import {
  getAreaLists,
  getDictInfoNew,
  qualificationsDetail,
  qualificationsUpgrade,
  updateUpgrade,
  queryExamCertificat,
  qualificationsUpgradeFile,
  delfile,
  submitQualificationsUpgrade,
  userInfo,
  checkExistsQualificationsUpgradeInfo,
} from "@/api/api.js";
export default {
  name: "",
  components: { Foot },
  props: {},
  data() {
    // 校验邮箱
    let checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电子邮箱"));
      } else {
        const reg =
          /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
        if (!reg.test(value)) {
          const msg = rule.msg ? rule.msg : "邮箱格式不正确";
          return callback(new Error(msg));
        } else {
          return callback();
        }
      }
    };
    let checkUserId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入统一社会信用代码"));
      } else {
        const reg = /^[A-Za-z0-9]{18}$/;
        // const regs = /^[A-Za-z0-9]{15}$/;
        if (!reg.test(value)) {
          const msg = rule.msg
            ? rule.msg
            : "统一社会信用代码长度18位数字、字母";
          return callback(new Error(msg));
        } else {
          return callback();
        }
      }
    };
    let checkphone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else {
        const reg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
        if (!reg.test(value)) {
          const msg = rule.msg ? rule.msg : "手机号格式不正确";
          return callback(new Error(msg));
        } else {
          return callback();
        }
      }
    };
    let checkIdcard = (rule, value, callback) => {
      if (this.ruleForm.idcardType == 1) {
        if (!value) {
          return callback(new Error("请输入身份证件号码"));
        } else {
          const reg =
            /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          if (!reg.test(this.ruleForm.idcardNum)) {
            const msg = rule.msg ? rule.msg : "身份证格式不正确";
            return callback(new Error(msg));
          } else {
            return callback();
          }
        }
      } else if (this.ruleForm.idcardType != 1) {
        if (!value) {
          return callback(new Error("请输入证件号码"));
        } else {
          return callback();
        }
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); // 选当前时间之后的时间
        },
      },
      show: true,
      active: 0,
      ruleForm: {
        userName: "",
        sex: "",
        idcardType: "",
        idcardNum: "",
        mobilePhone: "",
        email: "",
        technicalTitle: "",
        province: "", //省
        provinceCode: "",
        city: "", //市
        cityCode: "", //市代码
        countyCode: "", //区县代码
        county: "", //区县
        address: "",
        personIntroduction: "",
        unitName: "",
        creCode: "",
        industry: "",
        depart: "",
        post: "",
        workprovinceCode: "",
        workprovince: "",
        workcityCode: "",
        workcity: "",
        workcountyCode: "",
        workcounty: "",
        unitAddress: "",
        workText: "",
        dutyTime: "",
      },
      rules: {
        userName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            max: 15,
            message: "长度在 1 到 15 个字符",
            trigger: ["blur", "change"],
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        idcardType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        idcardNum: [
          { required: true, message: "证件号不能为空", trigger: "blur" },
          { validator: checkIdcard, trigger: ["blur", "change"] },
        ],
        mobilePhone: [
          {
            required: true,
            validator: checkphone,
            trigger: ["blur", "change"],
          },
        ],
        email: [
          {
            required: true,
            validator: checkEmail,
            trigger: ["blur"],
          },
        ],
        address: [
          {
            required: true,
            message: "请选择并输入详细地址",
            trigger: ["blur", "change"],
          },
          {
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: ["blur", "change"],
          },
        ],
        province: [
          {
            required: true,
            message: "请选择省",
            trigger: ["blur", "change"],
          },
        ],
        city: [
          {
            required: true,
            message: "请选择市",
            trigger: ["blur", "change"],
          },
        ],
        county: [
          {
            required: true,
            message: "请选择区/县",
            trigger: ["blur", "change"],
          },
        ],
        technicalTitle: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        personIntroduction: [
          {
            required: true,
            message: "请输入个人简介",
            trigger: "blur",
          },
        ],

        //

        workprovince: [
          {
            required: true,
            message: "请选择省",
            trigger: ["blur", "change"],
          },
        ],
        workcity: [
          {
            required: true,
            message: "请选择市",
            trigger: ["blur", "change"],
          },
        ],
        workcounty: [
          {
            required: true,
            message: "请选择区/县",
            trigger: ["blur", "change"],
          },
        ],
        // 工作信息
        unitName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
        creCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
          { validator: checkUserId, trigger: ["blur", "change"] },
        ],
        industry: [
          {
            required: true,
            message: "请选择技术领域",
            trigger: ["blur", "change"],
          },
        ],
        depart: [
          {
            required: true,
            message: "请输入所在部门",
            trigger: "blur",
          },
        ],
        post: [
          {
            required: true,
            message: "请输入所在岗位",
            trigger: "blur",
          },
        ],
        dutyTime: [
          {
            required: true,
            message: "请选择工作开始时间",
            trigger: ["blur"],
          },
        ],
        unitAddress: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
        ],

        workText: [
          {
            required: true,
            message: "请输入单位简介",
            trigger: "blur",
          },
        ],
      },
      formLabelWidth: "150px",
      province: [],
      city: [],
      area: [],
      listIndustry: [],
      idCardList: [],
      qualificaType: [],
      datafrom: {
        userinfo: {},
      },
      fileList: [],
      fileData: [],
      paramsid: "",
      qualType: "",
      nowQualLevel: "", // 当前资质
      nowtype: "",
      applyQualLevel: "", //申请资质
      applyQualLevelcode: "",
      disable: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getArea();
    getDictInfoNew("ZJLX").then((res) => {
      this.idCardList = res.data;
    });
    getDictInfoNew("ZZDJ").then((res) => {
      this.qualificaType = res.data;
    });
    getDictInfoNew("HYLX").then((res) => {
      this.listIndustry = res.data;
    });
    console.log(sessionStorage.getItem("qualType"));
    if (sessionStorage.getItem("qualType")) {
      this.typeFun(sessionStorage.getItem("qualType"));
    }
    if (this.$route.params.id && this.$route.params.id != "") {
      this.paramsid = this.$route.params.id;
      this.show = false;
      this.infoTab();
      sessionStorage.setItem("paramsId", this.paramsid);
    } else if (sessionStorage.getItem("paramsId")) {
      this.paramsid = sessionStorage.getItem("paramsId");
      this.infoTab();
      this.show = false;
      sessionStorage.setItem("paramsId", this.paramsid);
    } else {
      console.log(111);
    }
  },
  methods: {
    typeFun(ty) {
      this.qualType = ty;
      sessionStorage.setItem("qualType", this.qualType);
      queryExamCertificat(this.$qs.stringify({ certype: this.qualType })).then(
        (res) => {
          if (res.code == 1000) {
            this.show = false;
            this.nowQualLevel = res.data.cerRank;
            this.nowtype = res.data.cerRankCode;
            checkExistsQualificationsUpgradeInfo(
              this.$qs.stringify({ certype: this.qualType })
            ).then((res) => {
              if (res.code == 1000) {
                if (res.data) {
                  this.paramsid = res.data;
                  this.infoTab();
                } else {
                  this.infoTabs();
                }
              }
            });
            this.qualificaType.map((item) => {
              if (item.code == Number(res.data.cerRankCode) + 1) {
                console.log(item.value);
                this.applyQualLevel = item.value;
                this.applyQualLevelcode = item.code;
              }
            });
          } else if (res.code == 9003) {
            this.$message.error(res.msg);
            sessionStorage.removeItem("index");
            sessionStorage.removeItem("qualType");
            this.$router.push({
              name: "personalCenter",
            });
          } else {
            sessionStorage.removeItem("qualType");
            this.$message.error(res.msg);
          }
        }
      );
    },
    infoTab() {
      qualificationsDetail(this.$qs.stringify({ id: this.paramsid })).then(
        (res) => {
          this.nowtype = res.data.nowQualLevel;
          this.applyQualLevelcode = res.data.applyQualLevelcode;
          this.qualificaType.map((item) => {
            if (item.code == res.data.nowQualLevel) {
              this.nowQualLevel = item.value;
            }
          });
          this.qualificaType.map((item) => {
            if (item.code == res.data.applyQualLevel) {
              console.log(item.value);
              this.applyQualLevel = item.value;
            }
          });
          
          if (res.data.sex == "男") {
            res.data.sex = "1";
          } else if (res.data.sex == "女") {
            res.data.sex = "2";
          }
          this.qualType = res.data.qualType
          this.ruleForm = {
            id: res.data.id,
            userName: res.data.surname,
            sex: res.data.sex, //性别
            idcardType: res.data.idcardType, //证件类型
            idcardNum: res.data.idcardNum,
            mobilePhone: res.data.mobilePhone, //电话号码
            email: res.data.email,
            technicalTitle: res.data.postTitle, //职称
            province: res.data.province,
            city: res.data.city,
            county: res.data.county,
            countyCode: res.data.countyCode,
            cityCode: res.data.cityCode,
            provinceCode: res.data.provinceCode,
            address: res.data.address, //个人信息地址
            personIntroduction: res.data.personIntroduction, //个人简介
            unitName: res.data.unitName, //单位信息-名称
            creCode: res.data.creCode, //统一信用代码
            industry: res.data.industry, // 技术领域
            depart: res.data.depart, // 所在部门
            post: res.data.post, // 所在岗位
            workprovinceCode: res.data.unitProvinceCode,
            workprovince: res.data.unitProvince,
            workcityCode: res.data.unitCityCode,
            workcity: res.data.unitCity,
            workcountyCode: res.data.unitCountyCode,
            workcounty: res.data.unitCounty,
            unitAddress: res.data.unitAddress, // 单位详细地址
            dutyTime: res.data.workStartTime,
            workText: res.data.unitIntroduction, //单位简介
          };
          res.data.annexFileList.map((item) => {
            item.name = item.fileName;
          });
          this.fileList = res.data.annexFileList;
          console.log(this.ruleForm);
        }
      );
    },
    // 个人中心信息
    infoTabs() {
      if (sessionStorage.getItem("user")) {
        let user = JSON.parse(sessionStorage.getItem("user"));
        userInfo({ id: user.id }).then((res) => {
          let info = res.data.unitInfo;
          if (res.data.sex == "男") {
            res.data.sex = "1";
          } else if (res.data.sex == "女") {
            res.data.sex = "2";
          }
          
          this.ruleForm = {
            // imageUrl: res.data.photoPath, //图片上传
            userName: res.data.examUserName,
            sex: res.data.sex, //性别
            idcardType: res.data.idcardType, //证件类型
            idcardNum: res.data.idcardNum,
            mobilePhone: res.data.mobilePhone, //电话号码
            email: res.data.email,
            technicalTitle: res.data.technicalTitle,
            province: res.data.province,
            city: res.data.city,
            county: res.data.county,
            countyCode: res.data.countyCode,
            cityCode: res.data.cityCode,
            provinceCode: res.data.provinceCode,
            address: res.data.address,
            // 个人简介
            personIntroduction: res.data.introduction,

            unitName: info.unit_name,
            creCode: info.creCode,
            industry: info.industry,
            depart: info.depart,
            post: info.post,
            workprovinceCode: info.provinceCode,
            workprovince: info.province,
            workcityCode: info.cityCode,
            workcity: info.city,
            workcountyCode: info.countyCode,
            workcounty: info.county,
            unitAddress: info.unitAddress,
            dutyTime: info.workStartTime + " " + "00:00:00",
            // 单位简介
            workText: info.introduction,
          };
        });
      }
    },
    prev() {
      this.active--;
    },
    back() {
      if (this.paramsid && this.$route.params.code == 1) {
        sessionStorage.removeItem("index");
        this.$router.push({
          name: "personalCenter",
        });
      } else {
        this.active = 0;
        this.$router.go(0);
        sessionStorage.removeItem("qualType");
      }
    },
    next() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$refs.ruleForms.validate((valid) => {
            if (valid) {
              this.idCardList.map((item) => {
                if (item.value == this.ruleForm.idcardType) {
                  this.ruleForm.idcardType = item.code;
                }
              });

              this.datafrom.userinfo = {
                qualType: this.qualType, //资质类型
                nowQualLevel: this.nowtype, //当前资质等级
                applyQualLevel: this.applyQualLevelcode, //申请资质等级
                surname: this.ruleForm.userName,
                sex: this.ruleForm.sex,
                idcardType: this.ruleForm.idcardType,
                idcardNum: this.ruleForm.idcardNum,
                mobilePhone: this.ruleForm.mobilePhone,
                email: this.ruleForm.email,
                postTitle: this.ruleForm.technicalTitle,
                province: this.ruleForm.province, //省
                provinceCode: this.ruleForm.provinceCode,
                city: this.ruleForm.city, //市
                cityCode: this.ruleForm.cityCode, //市代码
                countyCode: this.ruleForm.countyCode, //区县代码
                county: this.ruleForm.county, //区县
                address: this.ruleForm.address,
                personIntroduction: this.ruleForm.personIntroduction,
                unitName: this.ruleForm.unitName,
                creCode: this.ruleForm.creCode,
                industry: this.ruleForm.industry,
                depart: this.ruleForm.depart,
                post: this.ruleForm.post,
                unitProvinceCode: this.ruleForm.workprovinceCode,
                unitProvince: this.ruleForm.workprovince,
                unitCityCode: this.ruleForm.workcityCode,
                unitCity: this.ruleForm.workcity,
                unitCountyCode: this.ruleForm.workcountyCode,
                unitCounty: this.ruleForm.workcounty,
                unitAddress: this.ruleForm.unitAddress,
                unitIntroduction: this.ruleForm.workText,
                workStartTime: this.ruleForm.dutyTime,
              };
              if (this.paramsid) {
                this.datafrom.userinfo.id = this.paramsid;
                updateUpgrade(this.datafrom.userinfo).then((res) => {
                  console.log(2222);
                  if (res.code == 1000) {
                    this.active++;
                  } else {
                    this.$message.error(res.msg);
                  }
                });
              } else {
                qualificationsUpgrade(this.datafrom.userinfo).then((res) => {
                  if (res.code == 1000) {
                    this.paramsid = res.data.id;
                    this.active++;
                    sessionStorage.setItem(
                      "formdata",
                      JSON.stringify(res.data)
                    );
                    this.datafrom.userinfo.id = res.data.id;
                  } else {
                    this.$message.error(res.msg);
                  }
                });
              }
            }
          });
        } else {
          window.scrollTo(0, 400);
        }
      });
      console.log(this.datafrom);
    },

    // 相关附件
    submitUploadtable(file, fileList) {
      this.fileList = fileList;
      this.fileData = fileList;
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["pdf", "doc", "docx"];
      const isSuffix = whiteList.indexOf(fileSuffix.toLowerCase()) === -1;
      const isLt10M = file.size / 1024 / 1024 > 10;
      console.log("this.fileList:", this.fileList, fileList);
      var a = 0;
      fileList.forEach((item, idx) => {
        if (file.name === item.name) {
          a++;
          if (a === 2) {
            this.$message({
              message: "该文件名称已经上传过",
              type: "warning",
            });
            this.fileList.splice(idx, 1);
            this.fileData.splice(idx, 1);
            return;
          }
        }
      });
      if (isSuffix) {
        this.$message.error("上传文件只能是 pdf、doc、docx格式");
        const currIdx = this.fileList.indexOf(file);
        this.fileList.splice(currIdx, 1);
        this.fileData.splice(currIdx, 1);
        return;
      }
      if (isLt10M) {
        this.$message.error("上传文件大小不能超过 10MB");
        const currIdx = this.fileList.indexOf(file);
        this.fileList.splice(currIdx, 1);
        this.fileData.splice(currIdx, 1);
        return;
      }

      // console.log(file.raw.type, filelist);
      // if (
      //   file.raw.type != "application/pdf" ||
      //   file.raw.type != "application/msword" ||
      //   file.raw.type !=
      //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      // ) {
      //   filelist.map(item=>{
      //     filelist.splice(item,1)
      //   })

      //   return false;
      // } else {

      // }
    },
    submit() {
      console.log(this.fileList, this.fileData);
      if (this.fileList.length == 0 && this.fileData.length == 0) {
        this.$message.warning("请上传至少一个案例附件");
      } else {
        console.log(this.fileData);
        let filedata = [];
        this.fileData.map((item) => {
          if (item.raw) {
            filedata.push(item);
          }
        });
        if (filedata.length != 0) {
          let formData = new FormData();
          filedata.forEach((item, index) => {
            if (!item.id) {
              formData.append("files", item.raw);
            }
          });
          formData.append("operId", this.datafrom.userinfo.id);
          this.disable = true;
          qualificationsUpgradeFile(formData).then((res) => {
            if (res.code == 1000) {
              this.disable = false;
              this.submitUpgrade();
            } else {
              this.disable = false;
              this.$message.error(res.msg);
            }
          });
        } else if (this.fileList.length != 0) {
          this.submitUpgrade();
        }
      }
    },
    submitUpgrade() {
      this.disable = true;
      submitQualificationsUpgrade(
        this.$qs.stringify({ id: this.datafrom.userinfo.id })
      ).then((res) => {
        if (res.code == 1000) {
          this.active = 2;
          this.disable = false;
        } else {
          this.$message.error(res.msg);
          this.disable = false;
        }
      });
    },
    // 相关附件
    handleRemove(file, fileList) {
      console.log(file, fileList);
      if (file.id != "") {
        delfile(this.$qs.stringify({ id: file.id })).then((res) => {
          if (res.code == 1000) {
            this.fileList.map((item, index) => {
              if (item.id == file.id) {
                this.fileList.splice(index, 1);
              }
            });
          }
        });
      }
      if (file && file.name != "")
        this.fileData.map((item, index) => {
          if (item.name == file.name) {
            this.fileData.splice(index, 1);
          }
        });
      this.fileList.map((item, index) => {
        if (item.name == file.name) {
          this.fileList.splice(index, 1);
        }
      });
    },

    getArea() {
      let params = {
        level: 1,
        parentCode: "",
      };
      getAreaLists(params).then((res) => {
        if (res.code == "1000") {
          this.province = res.data;
        }
      });
    },
    // 选择省市区方法
    // 个人信息-地址
    getprovince(event) {
      this.ruleForm.province = event.area_name;
      this.ruleForm.provinceCode = event.area_code;
      this.ruleForm.city = "";
      this.ruleForm.cityCode = "";
      this.ruleForm.county = "";
      this.ruleForm.countyCode = "";
      let data = {
        level: 2,
        parentCode: event.area_code,
      };
      getAreaLists(data).then((res) => {
        if (res.code == 1000) {
          this.city = res.data;
        }
      });
    },
    getcity(event) {
      this.ruleForm.city = event.area_name;
      this.ruleForm.cityCode = event.area_code;
      this.ruleForm.county = "";
      this.ruleForm.countyCode = "";
      let data = {
        level: 3,
        parentCode: event.area_code,
      };
      getAreaLists(data).then((res) => {
        if (res.code == 1000) {
          this.area = res.data;
        }
      });
    },
    getarea(event) {
      this.ruleForm.county = event.area_name;
      this.ruleForm.countyCode = event.area_code;
    },
    // 工作信息-选择省市区
    workProvince(event) {
      this.ruleForm.workprovince = event.area_name;
      this.ruleForm.workprovinceCode = event.area_code;
      this.ruleForm.workcity = "";
      this.ruleForm.workcityCode = "";
      this.ruleForm.workcounty = "";
      this.ruleForm.workcountyCode = "";
      let data = {
        level: 2,
        parentCode: event.area_code,
      };
      getAreaLists(data).then((res) => {
        if (res.code == 1000) {
          this.city = res.data;
        }
      });
    },
    workCity(event) {
      this.ruleForm.workcity = event.area_name;
      this.ruleForm.workcityCode = event.area_code;
      this.ruleForm.workcounty = "";
      this.ruleForm.workcountyCode = "";
      let data = {
        level: 3,
        parentCode: event.area_code,
      };
      getAreaLists(data).then((res) => {
        if (res.code == 1000) {
          this.area = res.data;
        }
      });
    },
    workArea(event) {
      this.ruleForm.workcounty = event.area_name;
      this.ruleForm.workcountyCode = event.area_code;
    },
  },
};
</script>
  
<style scoped lang="less">
.container {
  width: 100%;
  height: calc(100% - 81px);
  // overflow: auto;
  .imgBanner {
    width: 100%;
    height: 400px;
    background: url(../assets/banner.png) 100% 100% no-repeat;
    background-size: 100%;
  }
  .container-content {
    width: 80%;
    min-height: calc(100% - 140px);
    margin: -60px auto 30px auto;
    // margin: 30px auto;
    // height: calc(100% - 100px);
    // margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding-top: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    box-shadow: 2px 2px 1px 1px #f0f0f0;
  }
  .container-contents {
    width: 80%;
    min-height: calc(100% - 140px);
    margin: -60px auto 30px auto;
    // margin: 30px auto;
    // height: calc(100% - 100px);
    // margin: 0 auto;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    align-items: center;
    background: #fff;
    padding-top: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    box-shadow: 2px 2px 1px 1px #f0f0f0;
    .bodyText {
      width: 70%;
      margin: 0 auto;
      height: 400px;
      border: 1px dashed #a2a0a0;
      font-size: 16px;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 10px;
      // background: #d0fdfd;
      p{
        line-height: 30px;
      }
    }
    .typeInfo {
      .headerType {
        margin-top: 50px;
        display: flex;
        align-items: center;
        h1 {
          margin: 0 20px;
        }
        span {
          width: 360px;
          height: 1px;
          background: #afaeae;
          display: inline-block;
        }
      }
      .itemType {
        margin: 40px auto;
        display: flex;
        justify-content: space-between;
        div {
          border-radius: 10px;
          border: 1px solid #a2a1a1;
          padding: 40px 0;
          font-size: 20px;
          width:30%;
          text-align: center;
          // letter-spacing: wrap;
        }
      }
    }
  }

  .button {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;

    .el-button {
      margin: 0 20px;
    }
  }
  .topGrade {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px dashed #f0f0f0;
    margin-bottom: 40px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // align-items: center;
      h1 {
        margin-bottom: 30px;
      }
    }
  }
  .container-form {
    width: 80%;
    margin: 0 auto;

    // overflow: auto;
    // div{
    //     width: 90%;
    //     margin: 0 auto;
    //     // .el-from{
    //     //     width: 100%;
    //     // }
    // }
    .titleheader {
      font-size: 20px;
      height: 80px;
      line-height: 80px;
      border-bottom: 1px solid #f0f0f0;
      margin-bottom: 30px;
    }
    .item_three {
      text-align: center;
    }
    .item_four {
      height: 400px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      font-size: 20px;
      margin-top: 100px;
    }
    .upload-demo {
      width: 400px;
      // height: 300px;
      margin: 0 auto;
      // ::v-deep .el-upload-dragger{
      //     width: 400px;
      //     height: 300px;
      // }
      ::v-deep .el-upload-list__item-name {
        text-align: left;
      }
    }
  }

  .seleCity {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;

    ::v-deep .el-form-item {
      width: 100% !important;
    }

    ::v-deep .el-select {
      width: 98%;

      ::v-deep .el-input {
        width: 100% !important;
      }
    }
  }

  .el-select {
    width: 100%;
  }

  ::v-deep .el-steps--horizontal {
    width: 100%;
    margin: 0 auto;
  }

  ::v-deep .el-step__title.is-success {
    color: #000;
  }
  ::v-deep .el-step__head.is-process {
    color: #0e7ce4;
    border-color: #0e7ce4;
  }

  ::v-deep .el-step__head.is-success {
    color: #0e7ce4;
    border-color: #0e7ce4;
  }

  ::v-deep .el-step__head.is-success .el-step__line {
    background-color: #0e7ce4;
  }

  ::v-deep .el-step__head .is-process .el-step__line {
    background-color: #0e7ce4;
  }
}
</style>
  